module.exports = __webpack_public_path__ + "img/logo-elrecreo.fbc61dd6.png";